import { CommonModule } from '@angular/common';
import { Component, Input, Signal, Output, EventEmitter } from '@angular/core';
import { RunningSimulation, SimulationActionEvent } from '../../../core/models/simulation.model';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { getFileNameWithoutExtension } from '../../../utils/format.util';

@Component({
  selector: 'app-simulations-info',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule, MatButtonModule, MatChipsModule],
  templateUrl: './simulations-info.component.html',
  styleUrl: './simulations-info.component.scss',
})
export class SimulationsInfoComponent {
  @Input() title!: string;
  @Input() currentUserEmail!: string;
  @Input() runningSimulations!: Signal<RunningSimulation[]>;
  @Output() simulationAction = new EventEmitter<SimulationActionEvent>();

  // Make utility function available to template
  protected readonly getFileNameWithoutExtension = getFileNameWithoutExtension;

  onSimulationAction(id: string, action: 'Retry' | 'Cancel'): void {
    this.simulationAction.emit({ id, action });
  }

  getStatusClass(status: string): string {
    if (!status) return 'status-not-started';

    switch (status.toLowerCase()) {
      case 'failure':
        return 'status-failed';
      case 'initialization':
        return 'status-initialization';
      case 'running':
        return 'status-running';
      case 'success':
      case 'completed':
        return 'status-success';
      default:
        return 'status-default';
    }
  }
}
